import {graphqlRequest} from '@shopify/cli-kit/node/api/graphql';
import {AbortError} from '@shopify/cli-kit/node/error';

import {
  authBypassTokenDurationParse,
  errorHandler,
  Header,
} from '../utils/utils.js';

import {
  DeploymentCompleteQuery,
  DeploymentCompleteQueryVariables,
  DeploymentCompleteQueryData,
  DeploymentCompleteResponse,
} from './graphql/deployment-complete.js';
import type {DeploymentConfig} from './types.js';

export async function deploymentComplete(
  config: DeploymentConfig,
  deploymentId: string,
): Promise<DeploymentCompleteResponse> {
  const variables: DeploymentCompleteQueryVariables = {
    deploymentId,
    generateAuthBypassToken: config.generateAuthBypassToken,
  };

  if (config.generateAuthBypassToken) {
    variables.authBypassTokenDuration = authBypassTokenDurationParse(
      config.authBypassTokenDuration,
    );
  } else if (config.authBypassTokenDuration) {
    throw new AbortError(
      'authBypassTokenDuration is set but generateAuthBypassToken is not enabled',
    );
  }

  if (config.overriddenEnvironmentVariables) {
    variables.environmentVariables = config.overriddenEnvironmentVariables;
  }

  try {
    const response: DeploymentCompleteQueryData = await graphqlRequest({
      query: DeploymentCompleteQuery,
      api: 'Oxygen',
      url: `${config.deploymentUrl}/api/v2/admin/graphql`,
      token: config.deploymentToken.accessToken,
      variables,
      addedHeaders: {
        [Header.OxygenNamespaceHandle]: config.deploymentToken.namespace,
      },
    });

    if (response.deploymentComplete.userErrors.length >= 1) {
      throw new AbortError(
        `Failed to complete deployment: ${response.deploymentComplete.userErrors[0]?.message}`,
      );
    }

    return response.deploymentComplete;
  } catch (error) {
    errorHandler(error);

    throw error;
  }
}
